import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { ConfirmDialog, EditableCurrency } from "@activecollab/components";
import PropTypes from "prop-types";
import { showErrorToast, showSuccessToast } from "~/components/Toast";
import { moveExpenseToTrash } from "~/store/actions/actions.expenses";
import { translateBackendMessage } from "~/utils/handleErrorMessages";

export const ExpenseValue = ({ id, value, onChange, canEdit }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [dialogOpen, setDialogOpen] = useState(false);
  const [key, setKey] = useState(1);

  const handleSave = useCallback(
    (e) => {
      if (Number(e.target.value) > 0) {
        typeof onChange === "function" && onChange({ value: e.target.value });
      } else {
        setDialogOpen(true);
      }
    },
    [onChange]
  );

  const onCancel = useCallback(() => {
    setDialogOpen(false);
    setKey((prev) => prev + 1);
  }, []);

  const moveToTrash = useCallback(() => {
    dispatch(moveExpenseToTrash(id)).then((action) => {
      if (action?.error?.message) {
        showErrorToast(translateBackendMessage(action.error.message));
      } else {
        showSuccessToast(t("Expense moved to trash"));
      }
    });
  }, [dispatch, id, t]);

  return (
    <>
      <EditableCurrency
        value={value}
        disabled={!canEdit}
        onSave={handleSave}
        min={0}
        allowEmptyValue
        key={key}
      />

      <ConfirmDialog
        open={dialogOpen}
        dialogTitle={t("Move to trash")}
        dialogContent={t("Move expense to trash?")}
        confirmBtnText={t("Move")}
        onConfirm={moveToTrash}
        onCancel={onCancel}
      />
    </>
  );
};

ExpenseValue.propTypes = {
  id: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func,
  canEdit: PropTypes.bool,
};
